import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ControllerListarSegurosClinica } from "../Service/Services.seguros";
import { GetTokenDecoded } from "../utils/storeUsuario";

/* ============================================================================
   SEGUROS-PLANES · el seguro se lee de la URL, nunca de un estado global.

   POR QUÉ ESTE HOOK EXISTE (Trampa 1 del encargo): si el seguro viviera en un
   contexto o en un store, recargar la página, abrir en pestaña nueva o pasarle
   el enlace a un compañero dejaría la pantalla en blanco o —peor— mostrando el
   seguro equivocado. La URL es la única fuente de verdad, así que todas las
   pantallas del módulo lo resuelven por aquí y ninguna acepta el seguro como
   prop desde arriba.

   No hay `GET /seguros/:id` en el backend (ver informe FASE 0 §3): la ficha se
   arma con `/listar_seguros` + búsqueda por id, exactamente lo que ya hace hoy
   `Seguros.js`. No invento un endpoint para esto.

   Un `:idseguro` que no existe, que no es un número o al que el usuario no
   tiene acceso NO se distingue desde el cliente: el backend ya filtra la lista
   por `authorizedClinicIds`, así que un seguro ajeno simplemente no viene.
   Los tres casos se tratan igual y con el mismo mensaje —"no existe o no
   tienes acceso"—, que además es la respuesta correcta en seguridad: no
   confirma la existencia de un id que no te corresponde.
   ========================================================================== */

export default function useSeguroRuta() {
    const { idseguro: idCrudo } = useParams();

    // Se valida ANTES de pedir nada. `/configuracion/seguros/abc` no debe
    // provocar una petición.
    const idseguro = /^\d+$/.test(String(idCrudo || "")) ? Number(idCrudo) : null;

    const [seguro, setSeguro] = useState(null);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState(null);

    const cargar = useCallback(async () => {
        if (idseguro === null) {
            setSeguro(null);
            setError("identificador");
            setCargando(false);
            return;
        }
        setCargando(true);
        setError(null);
        try {
            const lista = await ControllerListarSegurosClinica(GetTokenDecoded().idclinica);
            const encontrado = (lista || []).find((s) => Number(s.idseguro) === idseguro);
            if (!encontrado) {
                setSeguro(null);
                setError("no-encontrado");
            } else {
                setSeguro(encontrado);
            }
        } catch (e) {
            setSeguro(null);
            setError("red");
        } finally {
            setCargando(false);
        }
    }, [idseguro]);

    useEffect(() => {
        cargar();
    }, [cargar]);

    return { idseguro, seguro, cargando, error, recargar: cargar };
}
